import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlueCityItem } from '../../definitions/blue-city-item';
import { ListItemComponent } from '@ui/shared/util-list';
import { DetailViewModule } from '@ui/shared/ui-detail-view';
import { DividerModule } from 'primeng/divider';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-blue-city-item-details',
    templateUrl: './blue-city-item-details.component.html',
    styleUrls: ['./blue-city-item-details.component.scss'],
    imports: [
        DetailViewModule,
        DividerModule,
    ],
})
export class BlueCityItemDetailsComponent implements ListItemComponent<BlueCityItem> {
    @Input()
    public listItem?: BlueCityItem;
}
